import React from "react";

function Configuration () {
  return (
    <div> this is list of Configurations</div>
  )
}

export default Configuration